export function LoadingDataSpinnerDirective() {
  return {
    restrict: 'E',
    template: '<div class="spinner spinner_loading"></div>',
  };
}
